// extracted by mini-css-extract-plugin
module.exports = {"gfeButton":"GfeButton_gfeButton__25krK"};